import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useCreateSession } from "../../api/create-session.mutation";
import { useRoutes } from "../../hooks/use-routes";
import { useOrderingStore } from "../../store/use-ordering-store";
import type { StandardRegistrationFormValues } from ".";
import { useValidationSchema } from "./validation-schema";

export const useRegistrationLogic = () => {
  const { personalDetails, agreements, setVerificationType, setVerificationTokenUuid } = useOrderingStore();
  const validationSchema = useValidationSchema();
  const { t } = useTranslation();
  const formMethods = useForm<StandardRegistrationFormValues>({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
  });
  const { mutate: createSession, error: simplifyRegistrationError, isLoading } = useCreateSession({});
  const { goToPhoneVerification, goToSimplifyRegistration } = useRoutes();

  useEffect(() => {
    if (!personalDetails || !agreements) goToPhoneVerification();
  }, [personalDetails, agreements, goToPhoneVerification]);

  useEffect(() => {
    setVerificationTokenUuid(undefined);
  }, [setVerificationTokenUuid]);

  const handleSimplifyRegistration = () => {
    if (!personalDetails) return;

    createSession(
      { phone: personalDetails.phone, dialCode: personalDetails.dialCode },
      {
        onSuccess: (data) => {
          setVerificationType(data.verificationType);
          setVerificationTokenUuid(data.verificationTokenUuid);
          goToSimplifyRegistration();
        },
      },
    );
  };

  const simplifyRegistrationErrorFormatted = simplifyRegistrationError
    ? t("COMMONS.ERRORS.GENERAL_API_ERROR")
    : undefined;
  return {
    isLoading,
    formMethods,
    handleSimplifyRegistration,
    simplifyRegistrationError: simplifyRegistrationErrorFormatted,
  };
};
